import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import handleChangePassword from '../../../../services/apollo/func/handle/handleChangePassword';
import handleForgotPassword from '../../../../services/apollo/func/handle/handleForgorPassword';
import handleResendVerificationCode from '../../../../services/apollo/func/handle/handleResendVerificationCode';
import handleCompletePassword from '../../../../services/apollo/func/handle/handleCompletePassword';

export const getSchema = (isChangePassword) => {
  let schema;
  if (isChangePassword) {
    schema = yup.object().shape({
      currentPassword: yup.string().trim().required(''),
      newPassword: yup.string().trim().required(''),
    });
  } else {
    schema = yup.object().shape({
      verificationCode: yup.string().trim().required(''),
      newPassword: yup.string().trim().required(''),
    });
  }
  return schema;
};

export const getChangePassordForm = schema => useForm({
  mode: 'onChange',
  defaultValues: {
    currentPassword: '',
    newPassword: '',
  },
  resolver: yupResolver(schema),
});


export const getForgotPasswordForm = schema => useForm({
  mode: 'onChange',
  defaultValues: {
    verificationCode: '',
    newPassword: '',
  },
  resolver: yupResolver(schema),
});

export const changePassword = async (payload) => {
  try {
    const input = {
      currentPassword: payload.currentPassword,
      newPassword: payload.newPassword,
    };
    const changePassword = await handleChangePassword({ input });
    return changePassword;
  } catch (error) {
    return {
      isSuccess: false,
      message: error.message,
    };
  }
};

export const triggerSendOTP = async (email) => {
  try {
    const sendOTP = await handleForgotPassword({ email });
    return sendOTP;
  } catch (error) {
    return {
      isSuccess: false,
      message: error.message,
    };
  }
};

export const triggerResendOTP = async (userId) => {
  try {
    const resendOTP = await handleResendVerificationCode({ userId });
    return resendOTP;
  } catch (error) {
    return {
      isSuccess: false,
      message: error.message,
    };
  }
};

export const completePassword = async (payload) => {
  try {
    const input = {
      email: payload.email,
      verificationCode: payload.verificationCode,
      newPassword: payload.newPassword,
    };
    const confirmPassword = await handleCompletePassword({ input });
    return confirmPassword;
  } catch (error) {
    return {
      isSuccess: false,
      message: error.message,
    };
  }
};
